import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { DashboardServiceService } from '../../../services/dashboard-service.service';
@Component({
  selector: 'app-payment-history',
  templateUrl: './payment-history.component.html',
  styleUrls: ['./payment-history.component.css'],
})
export class PaymentHistoryComponent implements OnInit {
  invoiceData: any = [];
  hostedToken: any;
  isLoaded: any;
  search: any;
  showResults: any = 5;
  active: any = [];
  start: any;
  end: any;
  url: any = environment.invoiceUrl;
  constructor(
    private dialog: MatDialog,
    private dashboardService: DashboardServiceService
  ) {
    //
  }

  ngOnInit(): void {
    //retrive payment history
    this.dashboardService.getPaymentHistory().subscribe((res: any) => {
      const invoiceData = JSON.parse(res);
      if (invoiceData.invoices.invoice.length) {
        this.invoiceData = invoiceData.invoices.invoice;
      } else {
        this.invoiceData.push(invoiceData.invoices.invoice);
      }
      this.hostedToken = invoiceData.hosted_login_token;
      this.active[0] = true;
      this.isLoaded = true;
      this.start = 0;
      this.end = this.showResults;
    });
  }

  closeModal(): void {
    this.dialog.closeAll();
  }

  paginatorChange(e: any): void {
    this.showResults = parseInt(e.target.value);
    this.start = 0;
    this.end = parseInt(e.target.value);
    this.active = [];
    this.active[0] = true;
  }

  changePage(index: any) {
    this.start = parseInt(this.showResults) * parseInt(index);
    this.end = parseInt(this.start) + parseInt(this.showResults);
    this.active = [];
    this.active[index] = true;
  }
}
